import { observable, action } from 'mobx';

class CommonStore {
  @observable appName = 'Graph Datas';
  @observable appLoaded = false;
  @observable isLoadingTags = false;
  @observable menuOpened = false;

  @action
  setAppLoaded() {
    this.appLoaded = true;
  }

  @action
  openMenu() {
    this.menuOpened = true;
  }
  
  @action
  closeMenu() {
    this.menuOpened = false;
  }
}
export default new CommonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.ts